module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hours-with-customers"
  }, [_c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "options": _vm.chartOptions,
      "series": _vm.chartOptions.series,
      "height": _vm.chartOptions.chart.height
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c6b227"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/components/hoursWithCustomers.vue
// module id = 903
// module chunks = 0